export const activitiesRequestsQueryKeys = {
  all: ["activitiesRequests"] as const,
  event: (eventId: string) =>
    [...activitiesRequestsQueryKeys.all, eventId] as const,
};
